export default () => ({
    countDownDate: 0,
    interval: null,

    time: {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
    },

    timeInMilliseconds: {
        second: 1000,
        minute: 1000 * 60,
        hour: 1000 * 60 * 60,
        day: 1000 * 60 * 60 * 24,
    },

    init() {
        window.addEventListener('cart::mainEvent', ({detail: mainEvent}) => {
            const mainEventCloseDate    = mainEvent[0].close_date;
            const extendAccessEndDate = this.$store.customer.subscription.extended_access_end_date;

            const date = !mainEvent[0].active ? extendAccessEndDate : mainEventCloseDate;

            this.initCount(date ?? 0);
        });
    },

    initCount(date) {
        if (Object.keys(date).length === 0 || !Boolean(date)) {
            this.countDownDate = 0;
            return;
        }

        this.countDownDate = new Date(date).getTime();

        if (isNaN(this.countDownDate)) {
            this.countDownDate = new Date().getTime();
        }

        this.render();
    },

    getCountDown() {
        const { day, hour, minute, second } = this.timeInMilliseconds;

        const now = new Date().getTime();
        const distance = this.countDownDate - now;

        if (this.countDownDate < now) {
            clearInterval(this.interval);

            return {
                days: "00",
                hours: "00",
                minutes: "00",
                seconds: "00",
            };
        }

        return {
            days: Math.floor(distance / day)
                .toString()
                .padStart(2, 0),
            hours: Math.floor((distance % day) / hour)
                .toString()
                .padStart(2, 0),
            minutes: Math.floor((distance % hour) / minute)
                .toString()
                .padStart(2, 0),
            seconds: Math.floor((distance % minute) / second)
                .toString()
                .padStart(2, 0),
        };
    },

    render() {
        this.interval = setInterval(() => {
            this.time = this.getCountDown();
        }, this.timeInMilliseconds.second);
    },
});
